import 'regenerator-runtime/runtime';
import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import homeSection from './sections/home';
import mapSection from './sections/nbn-map';
import popupSection from './sections/popup';
import hsFormSection from './sections/hsForm';
import coverageSection from './sections/coverage';
import {getCLS, getFID, getLCP} from 'web-vitals';

init();
modalSection();
headerSection();
homeSection();
mapSection();
popupSection();
hsFormSection();
coverageSection();

getCLS(console.log, true);



// WEBPACK FOOTER //
// ./source/scripts/main.js